import { render, staticRenderFns } from "./TractNoteForm.vue?vue&type=template&id=a22133fc&"
import script from "./TractNoteForm.vue?vue&type=script&lang=js&"
export * from "./TractNoteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports